/** Characteristics API may return `nom` as number or string — safe for labels */
export function displayNomUpper(nom: unknown): string {
  if (nom == null || nom === "") return "";
  return String(nom).toUpperCase();
}
